import { Injectable, inject } from '@angular/core';
import { APIService } from './APIService/api.service';
import { AuthService } from './Auth/auth.service';

@Injectable({ providedIn: 'root' })
export class LicenseService {
  private apiService = inject(APIService);
  private authService = inject(AuthService);

  constructor() {
    setInterval(() => {
      if (!this.authService.isLoggedIn()) {
        return;
      }
      this.authService.sendHeartbeat().subscribe();
    }, 30000);

    window.addEventListener('beforeunload', () => {
      if (!this.authService.isLoggedIn()) {
        return;
      }
      this.apiService.sendBreak().subscribe();
    });
  }
}
